import { render, staticRenderFns } from "./addSeat.vue?vue&type=template&id=2a2dbe57&scoped=true&"
import script from "./addSeat.vue?vue&type=script&lang=js&"
export * from "./addSeat.vue?vue&type=script&lang=js&"
import style0 from "./addSeat.vue?vue&type=style&index=0&id=2a2dbe57&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2dbe57",
  null
  
)

export default component.exports